import moment from "moment"
import Dropzone from "react-dropzone"

import { ICardCommercialOffersTabPrimary } from "./types"

import { useDeviceType } from "@hooks/useDeviceType"

import { SelectDate } from "@primitive/calendar"
import { getInputButton } from "@primitive/getInputButton"
import { DictSelectorContainer } from "@smart/dictSelector"

import { Button, Container, Divider, Empty, Flex, Input, Textarea, Toogle, ToolTip, Table } from "@ui/index"

import imgEmty from '@img/empty.svg'
import { IconDelete, IconDownload } from "@img/icons"

import css from './ui.module.scss'


/** Анкета комерческого предложения - Главная вкладка */
export const CardCommercialOfferTabPrimary = ({
    cardMode, fieldsError, programsList, filesList, dbNameList, dbNameSelected,
    txtApplicationID, txtCommercialOffersStatusID, txtCommercialOfferDate, 
    txtCommercialOffersStatusName, txtCommercialValidPeriodDate,
    txtDateNextCall, txtTimeNextCall, txtPhone, txtEmail, txtToWhom, txtComment,
    dictSelectorData, selectingCalendarDate,
    handlerOpenModalConfirm, handleOpenModalProgram, 
    handleFileUploader, handleOpenModalPreview, handleDownloadFiles, handleDeleteFiles
}: ICardCommercialOffersTabPrimary) => {
    const formatter = new Intl.NumberFormat('ru-RU')
    const deviceType = useDeviceType()

    return <>
        <Flex gap="20px">
            <Flex gap="5px" >
                <Divider gap="6px" prefix={<h4>База данных сайта</h4>} />

                <Flex gap="8px" flexDirection="row" flexWrap="wrap">
                    {dbNameList.length === 0 ? 'Базы данных не найдены' 
                        : dbNameList.map((item) => (
                            <Container padding="4px 3px 4px 10px" key={item.siteDbNameID} className={css['gr_1fr_auto']}>
                                <p>{item.siteDbNameDescription}</p>

                                <Toogle 
                                    checked={dbNameSelected.value === item.siteDbName ? true : false} 
                                    onChange={() => dbNameSelected.setValue(item.siteDbName)} 
                                />
                            </Container>
                        ))
                    }
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>Основная информация</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.applicationID ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" className="input_header">Номер заявки</Flex>
                            
                            <Input placeholder="Номер заявки" isReadOnly {...txtApplicationID}
                                suffix={<>
                                    {txtApplicationID.value && getInputButton('clear', txtApplicationID.reset)}

                                    <DictSelectorContainer dbName={dbNameSelected.value} dictName="applicationsNumber" 
                                        onSelect={(data) => { dictSelectorData('applicationsNumber', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                </>}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.commercialOfferDate ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата КП <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Дата КП" type='mask' mask='99.99.2099' {...txtCommercialOfferDate}
                                suffix={<>
                                    {txtCommercialOfferDate.value && getInputButton('clear', txtCommercialOfferDate.reset)}

                                    <SelectDate currentDate={txtCommercialOfferDate.value} onSelect={(date) => selectingCalendarDate('commercialOfferDate', date)}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.commercialValidPeriodDate ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Срок действия КП <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Срок действия КП" type='mask' mask='99.99.2099' {...txtCommercialValidPeriodDate}
                                suffix={<>
                                    {txtCommercialValidPeriodDate.value && getInputButton('clear', txtCommercialValidPeriodDate.reset)}

                                    <SelectDate currentDate={txtCommercialValidPeriodDate.value} onSelect={(date) => selectingCalendarDate('commercialValidPeriodDate', date)}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>} 
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.commercialOffersStatusName ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Статус КП <p className="pulse"></p></Flex>
                            
                            <Input placeholder="Статус КП" isReadOnly {...txtCommercialOffersStatusName}
                                suffix={
                                    <DictSelectorContainer isSearch={false} isScroll={false} dbName={dbNameSelected.value} dictName="commercialOffersStatus" 
                                        onSelect={(data) => { dictSelectorData('commercialOffersStatus', data) }}
                                    >{getInputButton('select')}</DictSelectorContainer>
                                }
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.dateNextCall ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" alignItems="center" className="input_header">Дата отложенного звонка 
                                {txtCommercialOffersStatusID.value === 2 && <p className="pulse"></p>}
                            </Flex>

                            <Input placeholder="Дата отложенного звонка" {...txtDateNextCall}
                                isDisabled={txtCommercialOffersStatusID.value !== 2} type='mask' mask='99.99.2099'
                                suffix={<>
                                    {txtDateNextCall.value && getInputButton('clear', txtDateNextCall.reset)}

                                    <SelectDate currentDate={txtDateNextCall.value} onSelect={(date) => selectingCalendarDate('dateNextCall', date)}>
                                        {getInputButton('calendar')}
                                    </SelectDate>
                                </>} 
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.timeNextCall ? 'input_error' : 'input_error input_error-active'}>
                            <Flex flexDirection="row" className="input_header">Время отложенного звонка</Flex>
                            
                            <Input placeholder="Время отложенного звонка" {...txtTimeNextCall}
                                isDisabled={txtCommercialOffersStatusID.value !== 2} type='mask' mask='99:99:00'
                                suffix={txtTimeNextCall.value && getInputButton('clear', txtTimeNextCall.reset)} 
                            />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>Об организации</h4>} />

                <Flex gap='15px'>
                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyPhone ? 'input_error' : 'input_error input_error-active'}>
                            <Flex gap="5px" flexDirection="row" className="input_header">Телефон</Flex>
                            
                            <Input placeholder="Телефон" {...txtPhone}
                                suffix={txtPhone.value && getInputButton('clear', txtPhone.reset)}
                            />
                        </Flex>

                        <Flex flexGrow={1} flexBasis='250px' className={!fieldsError.value.companyEmail ? 'input_error' : 'input_error input_error-active'}>
                            <Flex flexDirection="row" className="input_header">Email</Flex>
                            
                            <Input placeholder="Email" {...txtEmail}
                                suffix={txtEmail.value && getInputButton('clear', txtEmail.reset)}
                            />
                        </Flex>
                    </Flex>

                    <Flex gap="8px" flexDirection="row" justifyContent="space-between" flexWrap="wrap">
                        <Flex flexGrow={1}>
                            <Flex flexDirection="row" className="input_header">Кому</Flex>
                            <Textarea placeholder="Кому" rows={5} value={txtToWhom.value} onChange={(e) => txtToWhom.setValue(e.target.value)} />
                        </Flex>
                    </Flex>
                </Flex>
            </Flex>

            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>Комментарий</h4>} />
                <Textarea placeholder="Комментарий" rows={5} value={txtComment.value} onChange={(e) => txtComment.setValue(e.target.value)} />
            </Flex>


            <Flex gap="5px">
                <Divider gap="6px" prefix={<h4>Программы</h4>} suffix={
                    <Flex flexDirection="row" gap="10px" alignItems="center">
                        <ToolTip title='Добавить' placement="left">
                            <Button size="sm" padding="4px 8px" variant="iconPrimary" onClick={() => handleOpenModalProgram(true, 'new')}>
                                Добавить
                            </Button>
                        </ToolTip>
                    </Flex>
                } />

                <Table.Container>
                    <Table.Header paddingLeft="8px" paddingRight="46px" classNameContainer={css['hidden_600']} classNameContent={css['table_grid_columns_header_program']}>
                        <p>Наименование программы<br />Наименование программы фактическое</p>
                        <p className={css['hidden_1180']}>Тип программы<br />Тип аттестации</p>
                        <p className={css['hidden_720']} style={{textAlign: 'center'}}>Месяцы<br />Часы</p>
                        <p className={css['hidden_600']} style={{textAlign: 'center'}}>Сумма<br />Слушатели</p>
                    </Table.Header>

                    <Table.Content isScrollVertical={false}>
                        {programsList.value.length === 0
                            ? <Empty image={imgEmty} size='60px' title='Программы отсутствуют' />
                            : programsList.value.map((item, index) => (
                                <Table.Row key={item.commercialOfferProgramID}
                                    className={css['table_grid_columns_row_program']}
                                    onClick={() => handleOpenModalProgram(true, 'edit', {
                                        commercialOfferProgramID: item.commercialOfferProgramID,
                                        programName: item.programName,
                                        programNameActual: item.programNameActual,
                                        documentTypeID: item.documentTypeID,
                                        documentTypeName: item.documentTypeName,
                                        attestationTypeID: item.attestationTypeID,
                                        attestationTypeName: item.attestationTypeName,
                                        durationEducation: item.durationEducation,
                                        volumeHours: item.volumeHours,
                                        price: item.price,
                                        listenersCount: item.listenersCount
                                    })}>

                                    <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                        <p>{item.programName}</p>
                                        <p>{item.programNameActual}</p>
                                    </div>

                                    <div className={css['hidden_1180']} style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                        <p>{item.documentTypeName}</p>
                                        <p>{item.attestationTypeName}</p>
                                    </div>

                                    <div className={css['hidden_720']} style={{ textAlign: 'center' }}>
                                        <p>{item.durationEducation}</p>
                                        <p>{item.volumeHours}</p>
                                    </div>

                                    <div className={css['hidden_600']} style={{ textAlign: 'center' }}>
                                        <p>{formatter.format(Number(item.price))} ₽</p>
                                        <p>{item.listenersCount}</p>
                                    </div>

                                    <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                        <ToolTip title='Удалить' placement="left">
                                            <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'}
                                                onClick={(e) => { 
                                                    handlerOpenModalConfirm(true, 'Удаление программы', 'Вы действительно хотите удалить данную программу?', 'deleteProgram', item.commercialOfferProgramID)
                                                    e.stopPropagation() 
                                                }}
                                            ><IconDelete width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                        </ToolTip>
                                    </Flex>
                                </Table.Row>
                            ))
                        }
                    </Table.Content>
                </Table.Container>
            </Flex>


            <Flex gap="5px" isRendered={cardMode === 'edit'}>
                <Divider gap="6px" prefix={<h4>Файлы</h4>} suffix={
                    <Flex flexDirection="row" gap="10px" alignItems="center">
                        <Dropzone onDropAccepted={(files) => handleFileUploader(files)}>
                            {({ getRootProps, getInputProps }) => (
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <ToolTip title='Добавить' placement="left">
                                        <Button size="sm" padding="4px 8px" variant="iconPrimary">Добавить</Button>
                                    </ToolTip>
                                </div>
                            )}
                        </Dropzone>
                    </Flex>
                } />

            <Table.Container>
                <Table.Header paddingLeft="8px" paddingRight="78px" classNameContainer={css['hidden_600']} classNameContent={css['table_grid_columns_header_file']}>
                    <span>Наименование файла<br />Размер файла</span>
                    <span style={{textAlign: 'center'}}>Дата<br/>создания</span>
                </Table.Header>

                <Dropzone onDropAccepted={(files) => handleFileUploader(files)} multiple={true}>
                    {({ getRootProps, getInputProps, isDragAccept, isDragActive }) => (
                        <div {...getRootProps({ className: isDragAccept ? `dropZone_container dropZone_dragAccept` : `dropZone_container`, onClick: event => event.stopPropagation() })}>
                            <Table.Content isScrollVertical={false}>
                                {filesList.value.length === 0
                                    ? <Empty image={imgEmty} size='60px' title='Файлы отсутствуют' />
                                    : filesList.value.map((item, index) => (
                                        <Table.Row key={item.commercialOfferFileID}
                                            className={css['table_grid_columns_row_file']}
                                            onClick={() => handleOpenModalPreview(true, item.filePath, item.fileName)}
                                        >
                                            <div style={{ textWrap: 'nowrap', overflow: 'hidden' }}>
                                                <p>{item.fileName}</p>
                                                <p style={{ opacity: '.8' }}>Размер файла: {item.fileSize}</p>
                                            </div>

                                            <span className={css['hidden_600']} style={{textAlign: 'center'}}>
                                                <p>{moment(item.dateCreate).format('DD.MM.YYYY')}</p>
                                                <p>{moment(item.dateCreate).format('HH:mm:ss')}</p>
                                            </span>

                                            <Flex gap="2px" flexDirection="row" alignItems="center" justifyContent="center">
                                                <ToolTip title='Скачать' placement="left">
                                                    <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => { 
                                                        handleDownloadFiles(item.commercialOfferFileID)
                                                        e.stopPropagation() 
                                                    }}><IconDownload width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                                </ToolTip>

                                                <ToolTip title='Удалить' placement="bottomRight">
                                                    <Button variant="icon" size={deviceType === 'mobile' ? 'xs' : 'sm'} onClick={(e) => { 
                                                        handleDeleteFiles(item.commercialOfferFileID)
                                                        e.stopPropagation() 
                                                    }}><IconDelete width={deviceType === 'mobile' ? '16px' : '20px'} height={deviceType === 'mobile' ? '16px' : '20px'} /></Button>
                                                </ToolTip>
                                            </Flex>
                                        </Table.Row>
                                    ))
                                }
                            </Table.Content>
                        </div>
                    )}
                </Dropzone>
            </Table.Container>
            </Flex>
        </Flex>
    </>
}